// extracted by mini-css-extract-plugin
module.exports = {"link":"LinkItem_link__m54Cw"};